import PropTypes from 'prop-types';
import __ from "ramda/es/__";
import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import map from "ramda/es/map";
import cx from "ramda-extension/es/cx";
import React, { Component } from 'react';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
import { classNamesForModifierOverDisplays } from '../../../utils/cssUtils';
import { displaySize, displaySizeAlignType, displaySizeSpaceType } from '../gridPropTypesValidators';
import { classNamesForModifierAndDisplay } from '../gridUtils';
const COMPONENT_NAME = 'Grid';
class Grid extends Component {
    getChildContext() {
        return {
            alignmentsForDisplays: this.props.alignmentsForDisplays
        };
    }
    static CSS_MODIFIER_PREFIX = 'Grid--';
    static CSS_MODIFIER_COLUMN_COLLAPSE = 'ColumnCollapse';
    static CSS_MODIFIER_COLUMN_REVERSE = 'ColumnReverse';
    static CSS_MODIFIER_COLUMN_SEPARATE = 'ColumnSeparate';
    static CSS_MODIFIER_NO_GUTTER = 'NoGutter';
    static CSS_MODIFIER_TYPE_COLUMN = 'TypeColumn';
    static CSS_MODIFIER_REVERSE = 'Reverse';
    static CSS_MODIFIER_ROW_COLLAPSE = 'RowCollapse';
    static CSS_MODIFIER_ROW_SEPARATE = 'RowSeparate';
    classNamesForModifierOverDisplaysWithPrefix = curry(classNamesForModifierOverDisplays)('Grid--');
    classNamesForModifierAndDisplayWithoutPrefixAndSuffix = compose(map(classNamesForModifierAndDisplay(__, '', '', this.classNamesForModifierOverDisplaysWithPrefix)));
    render() {
        const { children, className, noGutterForDisplays, typeColumnForDisplays, columnCollapseForDisplays, columnReverseForDisplays, columnSeparateForDisplays, reverseForDisplays, rowCollapseForDisplays, rowSeparateForDisplays, alignmentsForDisplays, spacesForDisplays, ...other } = this.props;
        const noGutterClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_NO_GUTTER, noGutterForDisplays);
        const typeColumnClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_TYPE_COLUMN, typeColumnForDisplays);
        const columnCollapseClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_COLUMN_COLLAPSE, columnCollapseForDisplays);
        const columnReverseClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_COLUMN_REVERSE, columnReverseForDisplays);
        const columnSeparateClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_COLUMN_SEPARATE, columnSeparateForDisplays);
        const reverseClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_REVERSE, reverseForDisplays);
        const rowCollapseClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_ROW_COLLAPSE, rowCollapseForDisplays);
        const rowSeparateClassNames = this.classNamesForModifierOverDisplaysWithPrefix(Grid.CSS_MODIFIER_ROW_SEPARATE, rowSeparateForDisplays);
        const alignmentsClassNames = this.classNamesForModifierAndDisplayWithoutPrefixAndSuffix(alignmentsForDisplays);
        const spacesClassNames = this.classNamesForModifierAndDisplayWithoutPrefixAndSuffix(spacesForDisplays);
        const finalModifiersClassNames = [].concat(noGutterClassNames, typeColumnClassNames, columnCollapseClassNames, columnReverseClassNames, columnSeparateClassNames, reverseClassNames, rowCollapseClassNames, rowSeparateClassNames, alignmentsClassNames, spacesClassNames).join(' ');
        return /*#__PURE__*/ React.createElement("div", {
            className: cx('Grid', finalModifiersClassNames, className),
            ...other
        }, children);
    }
}
Grid.childContextTypes = {
    alignmentsForDisplays: PropTypes.arrayOf(displaySizeAlignType)
};
Grid.displayName = 'Grid';
Grid.propTypes = {
    /**
	 * Which alignment (constants.alignTypes) will be set for display (constants.displaySizes). It is possible to set several pairs displaySize:alignTypes. When it is set it applied for all children (GridCols) as default alignment configuration.
	 */ alignmentsForDisplays: PropTypes.arrayOf(displaySizeAlignType),
    /**
	 * Children will be rendered within the `Grid`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * {display}ColumnCollapse CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ columnCollapseForDisplays: PropTypes.arrayOf(displaySize),
    /**
	 * {display}ColumnReverse CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ columnReverseForDisplays: PropTypes.arrayOf(displaySize),
    /**
	 * {display}ColumnSeparate CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ columnSeparateForDisplays: PropTypes.arrayOf(displaySize),
    /**
	 * {display}NoGutter CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ noGutterForDisplays: PropTypes.arrayOf(displaySize),
    /**
	 * {display}Reverse CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ reverseForDisplays: PropTypes.arrayOf(displaySize),
    /**
	 * {display}RowCollapse CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ rowCollapseForDisplays: PropTypes.arrayOf(displaySize),
    /**
	 * {display}RowSeparate CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ rowSeparateForDisplays: PropTypes.arrayOf(displaySize),
    /**
	 * Which space (constants.spaceTypes) will be set for display (constants.displaySizes). It is possible to set several pairs spaceTypes:alignTypes.
	 */ spacesForDisplays: PropTypes.arrayOf(displaySizeSpaceType),
    /**
	 * {display}TypeColumn CSS selector will be set to display(s) (constants.displaySizes) pass as values in array.
	 */ typeColumnForDisplays: PropTypes.arrayOf(displaySize)
};
export { Grid };
export default withDefaultComponentProps(COMPONENT_NAME, {
    alignmentsForDisplays: [],
    spacesForDisplays: []
}, Grid);
